import { toast } from "react-toastify";
import { deleteDataSimple, getData, getDataSimple, postDataSimple, putData, putDataSimple, postData, deleteData } from '../../utils/serverHelper';
import { CATEGORIES, BUSINESS_PRESET } from "../../utils/urls";
import {
  failedCategories,
  failedPresets,
  loadingCategories,
  loadingPresets,
  successCategories,
  successPresets,
  successPresetsDetails,
} from "./reducer";
import { errorMessage } from "../error/action";

export const addCategories = async (dispatch,req,nav) => {
  try {
    console.log("here verify");
    dispatch(loadingCategories());
    await postData(BUSINESS_PRESET,req);
    await getCategories(dispatch);
    console.log('done categories');
    nav(-1);
    // console.log("here here verify", data?.data);
    // dispatch(successCategories(data?.data));
  } catch (error) {
    errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    // toast.error("Something went wrong", { position: toast.POSITION.TOP_RIGHT });
    console.log(error, "log here verify");
    dispatch(
      failedCategories({
        message: error.response?.data?.error?.message || error?.message,
      })
      );
    }
  };
  export const updateCategories = async (dispatch,req) => {
    try {
      console.log("here verify");
      dispatch(loadingCategories());
      await putData(BUSINESS_PRESET,req);
      await getCategories(dispatch);
      // nav(-1);
      // console.log("here here verify", data?.data);
    // dispatch(successCategories(data?.data));
  } catch (error) {
    errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    // toast.error("Something went wrong", { position: toast.POSITION.TOP_RIGHT });
    console.log(error, "log here verify");
    dispatch(
      failedCategories({
        message: error.response?.data?.error?.message || error?.message,
      })
    );
  }
};
export const deleteCategories = async (dispatch,req) => {
  try {
    console.log("here verify");
    dispatch(loadingCategories());
    await deleteData(BUSINESS_PRESET+'/'+req);
    await getCategories(dispatch);
    // console.log("here here verify", data?.data);
    // dispatch(successCategories(data?.data));
  } catch (error) {
    errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    // toast.error("Something went wrong", { position: toast.POSITION.TOP_RIGHT });
    console.log(error, "log here verify");
    dispatch(
      failedCategories({
        message: error.response?.data?.error?.message || error?.message,
      })
    );
  }
};

export const getCategories = async (dispatch, suppressErrorToast = false) => {
  try {
    console.log("🔍 [getCategories] Starting...");
    console.log("🔍 [getCategories] CATEGORIES URL:", CATEGORIES);
    dispatch(loadingCategories());
    const data = await getDataSimple(CATEGORIES);
    console.log("🔍 [getCategories] Full axios response:", data);
    console.log("🔍 [getCategories] Response type:", typeof data);
    console.log("🔍 [getCategories] Response keys:", Object.keys(data || {}));
    console.log("🔍 [getCategories] data.data:", data?.data);
    console.log("🔍 [getCategories] data.data type:", typeof data?.data);
    console.log("🔍 [getCategories] data.data length:", Array.isArray(data?.data) ? data.data.length : 'not an array');
    
    // Response structure: { success: true, data: [...], error: {} }
    // getDataSimple returns data.data (axios response body), so data is { success: true, data: [...], error: {} }
    // Therefore data.data is the array
    const categoriesArray = data?.data || [];
    console.log("✅ [getCategories] Categories array to dispatch:", categoriesArray);
    console.log("✅ [getCategories] Categories array length:", categoriesArray.length);
    if (categoriesArray.length > 0) {
      console.log("✅ [getCategories] First category:", categoriesArray[0]);
    }
    dispatch(successCategories(categoriesArray));
    console.log("✅ [getCategories] Successfully dispatched categories");
  } catch (error) {
    console.error("❌ [getCategories] Error occurred:", error);
    console.error("❌ [getCategories] Error response:", error.response);
    console.error("❌ [getCategories] Error message:", error.message);
    console.error("❌ [getCategories] Error response data:", error.response?.data);
    
    // Only show error toast if suppressErrorToast is false
    if (!suppressErrorToast) {
      errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');
    }

    // toast.error("Something went wrong", { position: toast.POSITION.TOP_RIGHT });
    console.log(error, "log here verify");
    dispatch(
      failedCategories({
        message: error.response?.data?.error?.message || error?.message,
      })
    );
  }
};

export const getCategoriesForms = async (dispatch,id) => {
  try {
    console.log("here verify");
    dispatch(loadingPresets());
    const data = await getDataSimple(BUSINESS_PRESET+'/'+id+'/forms');
    console.log("here here verify", data?.data);
    dispatch(successPresets(data?.data));
  } catch (error) {
    errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    // toast.error("Something went wrong", { position: toast.POSITION.TOP_RIGHT });
    console.log(error, "log here verify");
    dispatch(
      failedPresets({
        message: error.response?.data?.error?.message || error?.message,
      })
    );
  }
};

export const getCategoriesFormsDetails = async (dispatch,id,form_id) => {
  try {
    console.log("here verify",id,form_id);
    dispatch(loadingPresets());
    const data = await getDataSimple(BUSINESS_PRESET+'/'+id+'/forms');
    console.log("here here verify", data?.data);
    dispatch(successPresetsDetails({presets:data?.data,presetsDetails:data?.data?.filter(el=>el.form_id===form_id)}));
    return data?.data?.find(el=>el.form_id.toString()===form_id.toString());
  } catch (error) {
    errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    // toast.error("Something went wrong", { position: toast.POSITION.TOP_RIGHT });
    console.log(error, "log here verify");
    dispatch(
      failedPresets({
        message: error.response?.data?.error?.message || error?.message,
      })
      );
    return {};
  }
};


export const addPresets = async(dispatch,req,nav,id)=>{
  try {
    dispatch(loadingPresets());
    await postData(BUSINESS_PRESET+'/'+id+'/forms',req);
    await getCategories(dispatch,id);
    nav(-1);
  } catch (error) {
    errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    dispatch(
      failedPresets({
        message: error.response?.data?.error?.message || error?.message,
      })
    );
  }
}

export const updatePresets = async(dispatch,req,nav,id)=>{
  try {
    dispatch(loadingPresets());
    await putData(BUSINESS_PRESET+'/'+id+'/forms',req);
    await getCategories(dispatch,id);
    nav(-1);
  } catch (error) {
    errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    dispatch(
      failedPresets({
        message: error.response?.data?.error?.message || error?.message,
      })
    );
  }
}

export const deletePresets = async(dispatch,id,form_id)=>{
  try {
    dispatch(loadingPresets());

    await deleteData(BUSINESS_PRESET+'/'+form_id+'/forms');
    await getCategoriesForms(dispatch,id);
  } catch (error) {
    errorMessage(dispatch,error.response?.data?.error?.message || 'Server went down please try again later');

    console.log(error);
    dispatch(
      failedPresets({
        message: error.response?.data?.error?.message || error?.message,
      })
    );
  }
}

// export const getBusinessDetails = async (dispatch,id) => {
//     try {
//         console.log('here verify');
//         dispatch(loadingBusinessDetails());
//         const data = await getData(BUSINESS_ID(id));
//         console.log('here here verify', data?.data);
//         dispatch(successBusinessDetails(data?.data?.business));
//         dispatch(successBusinessServices(data?.data?.services));
//     } catch (error) {
//         toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
//         console.log(error, 'log here verify');
//         dispatch(failedBusinessDetails({ message: error.response?.data?.error?.message || error?.message }));
//     }
// }
// export const getBusinessServices = async (dispatch,id) => {
//     try {
//         console.log('here verify');
//         dispatch(loadingBusinessServices());
//         const data = await getData(BUSINESS_ID(id)+'/services');
//         console.log('here here verify', data?.data);
//         dispatch(successBusinessServices(data?.data));
//     } catch (error) {
//         toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
//         console.log(error, 'log here verify');
//         dispatch(failedBusinessService({ message: error.response?.data?.error?.message || error?.message }));
//     }
// }
// export const getBusinessStaff = async (dispatch,id) => {
//     try {
//         console.log('here verify');
//         dispatch(loadingBusinessStaff());
//         const data = await getData(BUSINESS_ID(id)+'/staff');
//         console.log('here here verify', data?.data);
//         dispatch(successBusinessStaff(data?.data));
//     } catch (error) {
//         toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
//         console.log(error, 'log here verify');
//         dispatch(failedBusinessStaff({ message: error.response?.data?.error?.message || error?.message }));
//     }
// }
// export const getBusinessCustomers = async (dispatch,id) => {
//     try {
//         console.log('here verify');
//         dispatch(loadingBusinessCustomers());
//         const data = await getData(BUSINESS_ID(id)+'/customers');
//         console.log('here here verify', data?.data);
//         dispatch(successBusinessCustomers(data?.data));
//     } catch (error) {
//         toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
//         console.log(error, 'log here verify');
//         dispatch(failedBusinessCustomers({ message: error.response?.data?.error?.message || error?.message }));
//     }
// }

// export const restrictBusiness = async (dispatch,id,restrict) => {
//     try {
//         console.log('here verify');
//         dispatch(loadingBusinessRestrict());
//         const data = await postData(BUSINESS_ID(id),{restrict});
//         console.log('here here verify', data?.data);
//         dispatch(successBusinessRestrict());
//         await getBusiness(dispatch);
//     } catch (error) {
//         toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
//         console.log(error, 'log here verify');
//         dispatch(failedBusinessRestrict({ message: error.response?.data?.error?.message || error?.message }));
//     }
// }

// export const renewBusiness = async (dispatch,id,restrict) => {
//     try {
//         console.log('here verify');
//         dispatch(loadingBusinessRestrict());
//         const data = await putData(BUSINESS_ID(id),{restrict});
//         console.log('here here verify', data?.data);
//         dispatch(successBusinessRestrict());
//         await getBusiness(dispatch);
//     } catch (error) {
//         toast.error('Something went wrong',{position:toast.POSITION.TOP_RIGHT});
//         console.log(error, 'log here verify');
//         dispatch(failedBusinessRestrict({ message: error.response?.data?.error?.message || error?.message }));
//     }
// }
